import { useEffect } from "react";

const useImageResize = () => {
  useEffect(() => {
    function setImageSize(img) {
      if (!img.complete || img.naturalWidth === 0) return;

      let naturalWidth = img.naturalWidth;
      let naturalHeight = img.naturalHeight;
      let renderedWidth = img.clientWidth; // Displayed width
      let aspectRatio = naturalHeight / naturalWidth;

      // If image is square, ensure it stays square
      let calculatedHeight =
        aspectRatio === 1 ? renderedWidth : Math.round(renderedWidth * aspectRatio);

      img.setAttribute("width", renderedWidth);
      img.setAttribute("height", calculatedHeight);
      img.style.objectFit = "cover"; // Ensures no distortion
    }

    function handleResize() {
      document.querySelectorAll("img").forEach(setImageSize);
    }

    function observeImages() {
      document.querySelectorAll("img").forEach((img) => {
        if (img.complete) {
          setImageSize(img);
        } else {
          img.addEventListener("load", () => setImageSize(img), { once: true });
        }
      });
    }

    // Initial check
    observeImages();

    // Listen for window resize
    window.addEventListener("resize", handleResize);

    // Use MutationObserver to handle dynamically added images
    const observer = new MutationObserver(() => observeImages());
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("resize", handleResize);
      observer.disconnect();
    };
  }, []);
};

export default useImageResize;